export const EMPTY_PORTFOLIO_STATS = {
  totalInvested: 0,
  portfolioValue: 0,
  totalProjects: 0,
  activeInvestments: 0,
};

/** Normalises KPI fields from dashboard or `/api/investments/me` payloads. */
export function parsePortfolioStats(dashboard) {
  const s = dashboard?.kpis ?? dashboard?.stats ?? {};
  return {
    totalInvested: Number(s.totalInvestedAmount ?? 0),
    portfolioValue: Number(s.totalShares ?? 0),
    totalProjects: Number(
      dashboard?.totalInvestedProjects  ??s.totalInvestedProjects ??
        s.totalProjects ??
        s.total_projects ??
        s.projectCount ??
        s.projectsCount ??
        0
    ),
    activeInvestments: Number(s.totalInvestments ?? 0),
  };
}
